import { createPinia } from 'pinia';
import resetStore from '@/utils/resetStore';

const pinia = createPinia();
pinia.use(resetStore);

export default pinia;
